// import PropTypes from 'prop-types';
import ReactEcharts from 'echarts-for-react';
import React, { Component } from 'react';
import { toast } from 'react-toastify';
import ColorPicker from '../../../../Colorpicker/index-beta';
import { useChartManagement } from 'src/managers/chartManager/stateManagement/management';

class PieChart extends Component {
  constructor(props) {
    super(props);
    const { error, chartType, cardType } = this.props;

    this.chartRef = React.createRef();

    this.configurationError = error;
    this.colorPickerRef = React.createRef();
    this.manager = useChartManagement(this);
  }

  shouldComponentUpdate(nextProps) {
    return this.manager.changesChecker(nextProps);
  }

  onChartReady(chart, onChartLoaded) {
    this.echarts = chart;
    if (onChartLoaded) onChartLoaded();
  }

  // Caso a api retorne um erro no fetch das configurações de cores, não será possivel abrir
  // o color picker e uma mensagem de erro será apresentada ao usuário.
  onConfigurationError() {
    toast.error(this.configurationError.toString());
  }

  /**
   * atualiza as configuracoes da instancia de echarts
   * passada.
   */
  updateOptions(newOptions) {
    this.setState((prevState) => ({
      ...prevState,
      options: {
        ...prevState.options,
        ...newOptions,
      },
    }));
  }

  render() {
    const options = this.manager.getOptions();
    const { colorPickerColors, chartRef } = this.props;

    return (
      <>
        <ReactEcharts
          ref={(echarts) => {
            if (chartRef) {
              chartRef.current = echarts;
            }
          }}
          option={options}
          onChartReady={(chart) => this.onChartReady(chart)}
          onEvents={{
            dblclick: (ctx) => this.manager.handleOnDoubleClick(ctx),
            legendselectchanged: (ctx) => this.manager.handleOnLegendChange(ctx),
          }}
        />
        <ColorPicker
          ref={this.colorPickerRef}
          hideColorPicker={() => this.manager.colorPickerHandler.hideColorPicker()}
          changeBarColor={(newColor) => this.manager.colorPickerHandler.changeColorHandler(newColor)}
          colors={colorPickerColors}
        />
      </>
    );
  }
}

// TODO: mudar para sizeAware
export default PieChart;
